/**
 * 判断是否是浏览器环境
 */
export const isBrowser = typeof window !== 'undefined'
  && typeof window.document !== 'undefined'
  && typeof window.document.createElement !== 'undefined';
